import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {SignupService} from "../../../merchant/services/signup.service";
import {CustomerSignupService} from "../../services/customer-signup-service";

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})
export class SignUpComponent implements OnInit {
  public signUpForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    protected customerSignupService: CustomerSignupService
  ) {}

  ngOnInit() {
    this.signUpForm = this.formBuilder.group({
      basicInfo: {
        name: ['', [Validators.required, Validators.maxLength(256)]],
        email: ['', [Validators.required, Validators.email, Validators.maxLength(320)]],
        password: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(64)]]
      },
      merchantInfo: null,
      contactInfo: null
    });

  }


}
